module.exports = __webpack_public_path__ + "ejemempleado.png?d4f860510f0f0d85bf717a1d49f98150";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ejemempleado.png
// module id = 850
// module chunks = 2